<template>
	<v-select
		v-model="model"
		:items="displayItems"
		:item-value="itemValueKey"
		item-text="__text"
		:label="label"
		:rules="rules"
		:disabled="disabled"
		:outlined="outlined"
		:required="required"
		:append-icon="appendIcon"
		:menu-props="menuProps"
		hide-details="auto"
		@change="$emit('change', $event)"
	/>
</template>

<script>
import { buildOptionText } from "@/utils/formatLabel";

export default {
	name: "FormatSelect",
	props: {
		value: [String, Number, null],
		items: { type: Array, default: () => [] },
		label: String,
		rules: Array,
		disabled: Boolean,
		outlined: { type: Boolean, default: true },
		required: Boolean,
		appendIcon: { type: String, default: "icon-angle-down" },
		menuProps: { type: Object, default: () => ({ offsetY: true }) },
		itemValueKey: { type: String, default: "key" },
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit("input", v);
			},
		},
		displayItems() {
			this.$i18n && this.$i18n.locale;
			const tBound = (key) => {
				const out = this.$t ? this.$t(key) : key;
				return out && out !== key ? out : key;
			};
			return (this.items || []).map((opt) => ({
				...opt,
				__text: buildOptionText(opt, tBound),
			}));
		},
	},
};
</script>
